// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f93fa668","732":"f070135f","977":"c91ad0c4"}[chunkId] + ".chunk.js";
};